import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { UsersHeaderTiles, UsersTable } from '../../../shared/containers'
import { userOperations } from '../../../../state/ducks/users'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { UserShape, PaginationShape } from '../../../../prop-types'

class UsersPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchUsers = this.fetchUsers.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchUsers()
  }

  fetchUsers () {
    this.props.fetchUsers(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchUsers())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Users</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout>
                    <PageHeaderLayout title={'Users'} subTitle={'All users'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <UsersHeaderTiles all_users={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchUsers}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All users</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <UsersTable users={this.props.users}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </UsersTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
UsersPage.propTypes = {
  users: arrayOf(UserShape).isRequired,
  fetchUsers: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
UsersPage.defaultProps = {
  users: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.users.fetchUsersReducer.loading,
  users: state.users.fetchUsersReducer.data.results,
  paginationData: state.users.fetchUsersReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchUsers: userOperations.list
}

// Export Class
const _UsersPage = connect(mapStateToProps, mapDispatchToProps)(UsersPage)
export { _UsersPage as UsersPage }
